import React from 'react';
import { GapCard, FocSubmit, LitePlanNotification } from '~/components/Patient';
import { getGapsByCategory, gapShouldShowControl } from '~/util';

interface FOCProps {
    patient: PatientType;
    status: number;
}
export function FOC({ patient, status }: FOCProps) {
    const gapsByCategory = getGapsByCategory(patient.foc_gaps, status)
        .map((x) => {
            if (x.name === 'FOC Measures') x.name = 'Primary';
            if (x.name === 'FOC Measures/Secondary') x.name = 'Secondary';
            return x;
        })
        .filter((x) => x.gaps.length > 0);

    return (
        <div>
            {gapShouldShowControl(status) && (
                <div className="row mb-3">
                    <div className="col text-end">
                        <FocSubmit patient={patient} />
                    </div>
                </div>
            )}
            <div className="patient-gaps-container">
                <LitePlanNotification show={patient?.metadata?.FOCVisibility === false} />
                {gapsByCategory.map((cat) => (
                    <div className="foc-gap-category-container" key={cat.name}>
                        <div>
                            <div className="h5 fw-bold">{cat.name}</div>
                        </div>
                        <div className="row">
                            {cat.gaps.map((gap: GapType) => (
                                <GapCard
                                    gap={gap}
                                    key={gap.id}
                                    patientId={patient.id}
                                    statusFilter={status}
                                />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
